import React from 'react';
import { Row, Col, Card, Statistic } from 'antd';
import {
  FileTextOutlined,
  UserOutlined,
  FolderOutlined,
  CalendarOutlined,
} from '@ant-design/icons';

interface FinanceStatisticsProps {
  statistics: {
    total_records: number;
    lead_records: number;
    case_records: number;
    today_records: number;
  } | null;
  loading: boolean;
}

const FinanceStatistics: React.FC<FinanceStatisticsProps> = ({ 
  statistics, 
  loading 
}) => {
  if (!statistics) return null;

  return (
    <Row gutter={16} style={{ marginBottom: 16 }}>
      <Col xs={24} sm={12} md={6}>
        <Card loading={loading}>
          <Statistic
            title="总财务记录数"
            value={statistics.total_records}
            prefix={<FileTextOutlined />}
            valueStyle={{ color: '#1890ff' }}
          />
        </Card>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Card loading={loading}>
          <Statistic
            title="线索财务记录数"
            value={statistics.lead_records}
            prefix={<UserOutlined />}
            valueStyle={{ color: '#52c41a' }}
          />
        </Card>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Card loading={loading}>
          <Statistic
            title="案件财务记录数"
            value={statistics.case_records}
            prefix={<FolderOutlined />}
            valueStyle={{ color: '#faad14' }}
          />
        </Card>
      </Col>
      <Col xs={24} sm={12} md={6}>
        <Card loading={loading}>
          <Statistic
            title="当日新增财务记录数"
            value={statistics.today_records}
            prefix={<CalendarOutlined />}
            valueStyle={{ color: '#722ed1' }}
          />
        </Card>
      </Col>
    </Row>
  );
};

export default FinanceStatistics;
